import type {
  MarketAnalyticsSubscriptionAttributes,
  MarketReportSubscriptionAttributes,
  Polygons
} from 'common'
import axios from 'axios'

import { coreClient, getToken } from '@/api/coreclient'

const apiUrl = import.meta.env.VITE_API_URL

export default {
  async list() {
    const client = await coreClient()
    return client.marketAnalytics
      .list()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return [] as MarketAnalyticsSubscriptionAttributes[]
      })
  },
  async get(id: number, options?: { logVisit?: boolean }) {
    const client = await coreClient()
    return client.marketAnalytics
      .get(id, options?.logVisit)
      .then((response) => response.data ?? null)
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async update(body: MarketAnalyticsSubscriptionAttributes) {
    const client = await coreClient()
    return client.marketAnalytics
      .update(body)
      .then((response) => {
        if (response.data) {
          return response.data
        }
        return null
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async delete(id: number) {
    const client = await coreClient()
    return client.marketAnalytics
      .delete(id)
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return false
      })
  },
  async create(body: MarketReportSubscriptionAttributes) {
    const client = await coreClient()
    return client.marketReport
      .create(body)
      .then((response) => {
        if (response.data) {
          return response.data
        }
        return null
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async boundaryFromComps(coordinates: number[][]): Promise<Polygons | null> {
    try {
      // Fallback to direct axios call (client method may not be generated yet)
      const token = await getToken()
      const response = await axios.post<{ data: Polygons | null }>(
        `${apiUrl}/market_analytics/boundary_from_comps`,
        { coordinates },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
      return response.data.data
    } catch (e: any) {
      console.error('Error getting census tract boundary from comps:', e)
      if (e.response) {
        console.error('Response status:', e.response.status)
        console.error('Response data:', e.response.data)
      }
      return null
    }
  }
}
